{
  "navbar": {
    "logout": "Salir"
  }
}
